import { render } from "./TextPrompting.vue?vue&type=template&id=4215ad07&scoped=true"
import script from "./TextPrompting.vue?vue&type=script&lang=js"
export * from "./TextPrompting.vue?vue&type=script&lang=js"

import "./TextPrompting.vue?vue&type=style&index=0&id=4215ad07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4215ad07"]])

export default __exports__